import { Observable } from 'rxjs/Observable';
import ajax from '@ui/services/api/ajax';

export interface RegionApi {
  getCountries: () => Observable<any>;
  getCitiesByCountry: (countryId: string) => Observable<any>;
  getCities: () => Observable<any>;
  createEntity: (entity: any) => Observable<any>;
  getRegions: () => Observable<any>;
  getManagerRegions: (managerId: any) => Observable<any>;
  getCitiesByRegion: (regionId: string) => Observable<any>;
  editEntity: (id: string, value: string, type: string) => Observable<any>;
  removeEntity: (id: string, type: string) => Observable<any>;
}

export const regionApi: RegionApi = {
  getCountries: () => ajax.get({ url: 'region/countries' }),
  getCitiesByCountry: (countryId: string) =>
    ajax.get({
      url: 'region/country-cities',
      params: { countryId },
    }),
  getCities: () => ajax.get({ url: 'region/cities' }),
  createEntity: entity =>
    ajax.post({
      url: 'region/create',
      body: { entity: JSON.stringify(entity) },
    }),
  getRegions: () => ajax.get({ url: 'region/regions' }),
  getManagerRegions: managerId =>
    ajax.get({ url: `region/manager-regions/${managerId}` }),
  getCitiesByRegion: regionId =>
    ajax.get({
      url: 'region/region-cities',
      params: { regionId },
    }),
  editEntity: (id: string, value: string, type: string) =>
    ajax.post({
      url: 'region/edit-region',
      body: { entity: JSON.stringify({ id, value, type }) },
    }),
  removeEntity: (id: string, type: string) =>
    ajax.post({
      url: 'region/remove',
      body: { entity: JSON.stringify({ id, type }) },
    }),
};



// WEBPACK FOOTER //
// ./src/api/region/region.ts